import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './ImagePreview.module.css';

const ImagePreview = ({ src, alt, className, style, fallbackIcon }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!src && fallbackIcon) {
    return (
      <div className={`${styles.fallbackContainer} ${className || ''}`} style={style}>
        {fallbackIcon}
      </div>
    );
  }

  return (
    <>
      <motion.img
        src={src}
        alt={alt}
        className={`${styles.thumbnail} ${className || ''}`}
        style={style}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      />

      {typeof document !== 'undefined' && createPortal(
        <AnimatePresence>
          {isOpen && (
            <motion.div
              className={styles.overlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
            >
              <motion.button
                className={styles.closeButton}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </motion.button>
              
              <motion.img
                src={src}
                alt={alt}
                className={styles.fullImage}
                initial={{ scale: 0.5, opacity: 0, y: 50 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.5, opacity: 0, y: 50 }}
                transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                onClick={(e) => e.stopPropagation()}
              />
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}
    </>
  );
};

export default ImagePreview;
